<template>
  <div>
    <div :class="[add_influencer_modal ? 'overlay open' : 'overlay']" @click="closeAddInfluencer()"></div>
    <div :class="[add_influencer_modal ? 'pr-detail-modal open' : 'pr-detail-modal']">
      <div class="request-pr-wrap" v-if="add_influencer_modal">
        <div class="request-pr-title" style="font-size: 16px">インフルエンサーの追加</div>
        <div class="request-pr-form">
          <div class="request-pr-form-wrap">
            <div class="request-pr-form-title">
              リストに追加したいインフルエンサーを選択してください
            </div>
            <influencerSuggest
              @syncInfluencerList="syncInfluencerList"
              :referer="'list'"
              :sns_type="sns_type"
              :influencer_list.sync="suggest_list"
              :influencer_bulk.sync="influencer_bulk"
              :report_switch.sync="report_switch"
            />
          </div>
          <div class="request-pr-form-buttonarea">
            <div v-if="create_request_enabled" class="report-detail-noinfluencer">
              追加したいインフルエンサーが登録されていない場合は
              <router-link to="/request" target="_blank">
                <span class="router-link"
                  >こちら
                  <font-awesome-icon :icon="['far', 'external-link']" style="margin-right: 3px" />
                </span>
              </router-link>
              からリクエストできます
            </div>
            <div class="flex-space"></div>
            <el-button @click="importInfluencer()" type="primary" :disabled="import_loading">
              <div class="flex-row">
                インフルエンサーを追加
                <div class="loader--mini" v-show="import_loading"></div>
              </div>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const addInfluencerAPI = root + "/api/list/add_influencer";
const addInfluencerBulkAPI = root + "/api/list/add_influencer_bulk";
import influencerSuggest from "../report/influencer_suggest";

export default {
  name: "listImport",
  props: ["add_influencer_modal", "list_id", "list_name", "sns_type"],
  components: {
    influencerSuggest,
  },
  data() {
    return {
      addList: [],
      suggest_list: [],
      report_switch: "left",
      influencer_bulk: "",
      import_loading: false,
      siteName: "REECH DATABASE"
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    create_request_enabled() {
      return this.$store.state.service_plan.create_request_enabled;
    },
  },
  created() {},
  mounted() {},
  methods: {
    syncInfluencerList(value) {
      this.addList = value;
    },
    importInfluencer() {
      // 入力バリデーション
      if (this.report_switch === "left") {
        if (!this.addList || this.addList.length === 0) {
          this.$message({
            type: "error",
            message: "インフルエンサーを1人以上選択してください。",
            showClose: true,
          });
          return;
        }
      } else {
        if (!this.influencer_bulk || this.influencer_bulk.trim() === "") {
          this.$message({
            type: "error",
            message: "インフルエンサーの情報を入力してください。",
            showClose: true,
          });
          return;
        }
      }
      this.import_loading = true;
      var params = new URLSearchParams();
      params.append("list_id", this.list_id);
      params.append("influencer", this.report_switch == "left" ? JSON.stringify(this.addList) : this.influencer_bulk);
      params.append("sns_type", this.sns_type);
      params.append("token", this.token);
      this.axios
        .post(this.report_switch == "left" ? addInfluencerAPI : addInfluencerBulkAPI, params)
        .then((response) => {
          if (response.data.noexist_count > 0) {
            this.$confirm(
              "<div>下記の" +
                response.data.noexist.length +
                '名のインフルエンサーは' + this.siteName + 'に未登録のためリストに追加できませんでした。<div class="import-influencer-noexist"><div>' +
                response.data.noexist_str +
                "</div>",
              "一部のインフルエンサーが追加できませんでした",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.create_request_enabled ? "上記インフルエンサーの新規登録をリクエスト" : "OK",
                cancelButtonText: "閉じる",
                showCancelButton: true,
                type: "warning",
                customClass: "import-influencer",
              }
            ).then(() => {
              if (this.create_request_enabled) {
                this.$router.push({
                name: "request",
                params: {
                  influencer_bulk: response.data.noexist_str_for_request,
                  sns_type: this.sns_type,
                  request_drawer: true,
                },
              });
              }
            });
          } else {
            if (response.data.status === "NG") {
              this.$message({
                type: "error",
                offset: 7,
                showClose: true,
                message: "インフルエンサーを" + this.list_name + "に追加できませんでした",
              });
            } else {
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: "インフルエンサーを" + this.list_name + "に追加しました",
              });
            }
          }
          this.addList = [];
          this.suggest_list = [];
          this.influencer_bulk = "";
          this.report_switch = "left";
          this.import_loading = false;
          this.closeAddInfluencer();
          this.$emit("loadQuery");
          this.$emit("loadList");
          this.$emit("loadListDetail");
        })
        .catch(() => {
          this.import_loading = false;
        });
    },
    closeAddInfluencer() {
      this.$emit("update:add_influencer_modal", false);
      document.documentElement.style.overflow = "auto";
    },
  },
  destroyed() {},
  watch: {
    sns_type() {
      this.addList = [];
      this.suggest_list = [];
      this.influencer_bulk = "";
    },
  },
  filters: {},
};
</script>

<style></style>
